export function handleProjectAccordion() {
    $('.js-project-accordion-container').css('height', '1070px');

    $('body').on('click', '.js-project-accordion-button', function() {
        let $parent = $(this).closest('.project-accordion__project');
        let $container = $parent.find('.js-project-accordion-container');
        let $button = $(this);

        if ($parent.hasClass('partially-open')) {
            $parent.removeClass('partially-open').addClass('active');
            $container.stop().animate({ height: $container.get(0).scrollHeight }, 300);
            $button.text('See less');
        } else if ($parent.hasClass('active')) {
            $parent.removeClass('active').addClass('partially-open');
            $container.stop().animate({ height: '1070px' }, 300);
            $button.text('See more');
        } else {
            $parent.addClass('active');
            $container.stop().animate({ height: $container.get(0).scrollHeight }, 300);
            $button.text('See less');
        }
    });
}
